export type GuestPosition = Pick<GeolocationCoordinates, "latitude" | "longitude" | "accuracy">;

/** Permission denial, unavailable positioning and timeouts all leave the visitor choosing manually. */
export const requestGuestPosition = (): Promise<GuestPosition | null> =>
  new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords: { latitude, longitude, accuracy } }) => resolve({ latitude, longitude, accuracy }),
      () => resolve(null),
      { enableHighAccuracy: true, maximumAge: 0, timeout: 10_000 },
    );
  });
